import { render, staticRenderFns } from "./checkCancelRecord.vue?vue&type=template&id=b5a1e70e&scoped=true"
import script from "./checkCancelRecord.vue?vue&type=script&lang=js"
export * from "./checkCancelRecord.vue?vue&type=script&lang=js"
import style0 from "./checkCancelRecord.vue?vue&type=style&index=0&id=b5a1e70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a1e70e",
  null
  
)

export default component.exports